import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';

import {
  PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuProcessos = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Processos"
    icon={<AssignmentIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR] &&
      hasResource('atividades_processos')}
    {permissoes[PERMISSAO_TELA_ATIVIDADES_LISTAR] &&
      hasResource('instancias_atividades_processos')}
  </SubMenu>
);

export default SubMenuProcessos;
